<div>
  <h2 mat-dialog-title>Delete Offer</h2>
  <mat-dialog-content>
    <p class="tw-pt-3">Deleting this offer will also remove it from Borrower Portal. Are you sure you want to delete this?</p>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-footer-container">
    <button mat-flat-button mat-dialog-close>Cancel</button>
    <button
      data-cy="offer-delete-confirm"
      mat-raised-button
      color="primary"
      (click)="deleteOffer()"
      data-cy="confirm-delete-offer">
      Yes
    </button>
  </mat-dialog-actions>
</div>
